<!-- 兑换详情 -->
<template>
  <div class="exchange-container">
    <div class="address-wrapper">
      <div class="left">
        <div class="title">
          <!-- <div>默认</div> -->
          <p>{{order.name}}</p>
          <span>{{order.mobile}}</span>
        </div>
        <p class="address">{{order.address}}</p>
      </div>
    </div>
    <div class="product-wrapper" v-if="orderId">
      <img :src="product.images.length ? product.images[0] : defaultImg">
      <div class="product-detail">
        <h3>{{product.name}}{{product.spec}}</h3>
        <p>{{product.intro}}</p>
        <p><img src="../../../assets/icon/icons8-expensive_2@2x.png"><span>{{product.credit}}</span></p>
      </div>
    </div>
    <div class="product-wrapper" v-if="lotteryId">
      <img :src="product.image ? product.image : defaultImg">
      <div class="product-detail">
        <h3>{{product.name}}</h3>
        <p>{{product.intro}}</p>
        <p>价值<span>￥{{product.price}}</span></p>
      </div>
    </div>
    <div class="express-wrapper">
      <p>物流信息</p>
      <span v-if="order.express_serial">{{order.express | expressFilter}} {{order.express_serial}}</span>
      <span v-else>暂未发货</span>
    </div>
    <!-- <div class="button" @click="toExchange">立即兑换</div> -->
  </div>
</template>

<script>
// import Vue from 'vue'
// import { Dialog } from 'vant'
// import { Toast } from 'vant'

export default {
  data() {
    return {
      orderId: null,
      lotteryId: null,
      order: {},
      product: { images: [] },
      defaultImg: require('../../../assets/img/img_sample.png')
    }
  },
  filters: {
    expressFilter(express) {
      const expressMap = {
        1: '顺丰快递',
        2: '申通快递',
        3: '中通快递',
        4: '韵达快递',
        5: '天天快递'
      }
      return expressMap[express]
    }
  },
  created() {
    if (this.$route.query.orderId) {
      this.orderId = this.$route.query.orderId
      this.getOrder()
    }
    if (this.$route.query.lotteryId) {
      this.lotteryId = this.$route.query.lotteryId
      this.getLottery()
    }
  },
  methods: {
    getOrder() {
      var that = this
      this.axios.get('/order/' + this.$route.query.orderId).then(function(res) {
        that.order = res.data
        that.getProduct()
      }).catch(function(error) {
        console.log(error)
      })
    },

    getLottery() {
      var that = this
      this.axios.get('/order/lottery/' + this.$route.query.lotteryId + '/').then((res) => {
        that.order = res.data
        that.product = res.data.product
      }).catch((err) => {
        console.log(err)
      })
    },

    getProduct() {
      var that = this
      this.axios.get('/product/' + this.order.product.id).then(function(res) {
        that.product = res.data
      }).catch(function(error) {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.exchange-container{
  .address-wrapper{
    width: 345px;
    height: 73px;
    padding: 0 10px;
    background-color: #ffffff;
    margin: 10px auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left{
      .title{
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        div{
          width: 31px;
          height: 16px;
          border-radius: 2px;
          background-color: #003485;
          color: #ffffff;
          font-size: 10px;
          font-weight: 400;
          text-align: center;
          line-height: 16px;
          margin-right: 5px;
        }
        p{
          color: #4a4a4a;
          font-size: 14px;
          font-weight: 600;
          margin-right: 5px;
        }
        span{
          color: #747474;
          font-size: 14px;
          font-weight: 400;
        }
      }
      .address{
        color: #747474;
        font-size: 12px;
        font-weight: 400;
        width: 340px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
  .product-wrapper{
    width: 345px;
    height: 80px;
    padding: 10px;
    margin: 0 auto;
    background-color: #ffffff;
    display: flex;
    img{
      width: 80px;
      height: 80px;
    }
    .product-detail{
      display: flex;
      margin-left: 10px;
      flex-direction: column;
      justify-content: space-between;
      h3{
        color: #747474;
        font-size: 14px;
        font-weight: 600;
      }
      p{
        display: flex;
        align-items: center;
        img{
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
        span{
          color: #f5a623;
          font-size: 12px;
          font-weight: 600;
        }
      }
    }
  }
  .express-wrapper{
    width: 345px;
    height: 50px;
    padding: 0 10px;
    margin: 10px auto 0;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    p{
      color: #4a4a4a;
      font-size: 14px;
      font-weight: 400;
    }
    span{
      opacity: 0.7;
      color: #4a4a4a;
      font-size: 13px;
      font-weight: 400;
    }
  }
  .button{
    width: 100%;
    height: 66px;
    background-color: #ff6d63;
    text-align: center;
    line-height: 66px;
    color: #ffffff;
    font-size: 18px;
    font-weight: 600;
    position: fixed;
    bottom: 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/user/exchange/detail.vue